(function($) {
  $('.product-slider').slick({
    fade: true,
    autoplay: true,
    arrows: false,
    dots: false,
    speed: 0,
    autoplaySpeed: 200,
  });
  $('.product-slider-control').on('click', '.js-play', function(e) {
    $('.product-slider').slick('slickPlay');
    return false;
  }).on('click', '.js-stop', function(e) {
    $('.product-slider').slick('slickPause');
    return false;
  }).on('click', '.js-prev', function(e) {
    $('.product-slider').slick('slickPrev');
    return false;
  }).on('click', '.js-next', function(e) {
    $('.product-slider').slick('slickNext');
    return false;
  })
  $('.product-mark').on('mouseenter', '.mark', function(e) {
    var ind = $(this).index();
    console.log(ind);
    
    $('.product-mark-list li').eq(ind).addClass('active');
  }).on('mouseleave', '.mark', function(e) {
    $('.product-mark-list li').removeClass('active');
  })
  initPhotoSwipeFromDOM('.gallery');
})($);